import type { RouteObject } from "react-router-dom";
import AppError from "../app-error";
import BrandsList, { brandsListLoader } from "./brands/List";
import NewBrand from "./brands/New";
import BrandDetail, { brandDetailLoader } from "./brands/Detail";
import CategoriesList, { categoriesListLoader } from "./categories/List";
import NewCategory, { newCategoryLoader } from "./categories/New";
import CategoryDetail, { categoryDetailLoader } from "./categories/Detail";
import ProductsList, { productsListLoader } from "./products/List";
import NewProduct, { productNewLoader } from "./products/New";
import ProductDetail, { productDetailLoader } from "./products/Detail";
import NewTier from "../tiers/New";
import TiersList, { tiersListLoader } from "../tiers/List";
import TierDetail, { tierDetailLoader } from "../tiers/Detail";
import TierRules, { tierRulesLoader } from "../tiers/Rules";
import TierPrices, { tierPricesLoader } from "../tiers/prices/List";
import SkusList, { skusListLoader } from "./skus/List";
import NewSku, { newSkuLoader } from "./skus/New";
import SkuDetail, { skuDetailLoader } from "./skus/Detail";
import SkuUnits, { skuUnitsLoader } from "./skus/Units";
import BasePrices, { basePricesLoader } from "./skus/BasePrices";
import GstRatesPage, { gstRatesListLoader } from "./gst-rates/List";

/** Catalogue + Tiers routes, spread into the root route's children in main.tsx. */
export const catalogueRoutes: RouteObject[] = [
  { path: "catalogue/brands", Component: BrandsList, loader: brandsListLoader, errorElement: <AppError /> },
  { path: "catalogue/brands/new", Component: NewBrand, errorElement: <AppError /> },
  { path: "catalogue/brands/:slug", Component: BrandDetail, loader: brandDetailLoader, errorElement: <AppError /> },
  { path: "catalogue/categories", Component: CategoriesList, loader: categoriesListLoader, errorElement: <AppError /> },
  { path: "catalogue/categories/new", Component: NewCategory, loader: newCategoryLoader, errorElement: <AppError /> },
  { path: "catalogue/categories/:slug", Component: CategoryDetail, loader: categoryDetailLoader, errorElement: <AppError /> },
  { path: "catalogue/products", Component: ProductsList, loader: productsListLoader, errorElement: <AppError /> },
  { path: "catalogue/products/new", Component: NewProduct, loader: productNewLoader, errorElement: <AppError /> },
  { path: "catalogue/products/:slug", Component: ProductDetail, loader: productDetailLoader, errorElement: <AppError /> },
  // T103 — GAP-1 closed: GET /skus exists, so the list route replaces the T053 GAP-1 workaround.
  { path: "catalogue/skus", Component: SkusList, loader: skusListLoader, errorElement: <AppError /> },
  { path: "catalogue/skus/new", Component: NewSku, loader: newSkuLoader, errorElement: <AppError /> },
  { path: "catalogue/skus/:slug", Component: SkuDetail, loader: skuDetailLoader, errorElement: <AppError /> },
  { path: "catalogue/skus/:slug/view", element: <SkuDetail readOnly />, loader: skuDetailLoader, errorElement: <AppError /> },
  { path: "catalogue/skus/:slug/units", Component: SkuUnits, loader: skuUnitsLoader, errorElement: <AppError /> },
  { path: "catalogue/skus/:slug/base-prices", Component: BasePrices, loader: basePricesLoader, errorElement: <AppError /> },
  // BUG-08: GstRate registry the SKU form's GST rate dropdown reads from.
  { path: "catalogue/gst-rates", Component: GstRatesPage, loader: gstRatesListLoader, errorElement: <AppError /> },
  // T059 — tier list; its name cell links to T061's tier settings screen below.
  { path: "tiers", Component: TiersList, loader: tiersListLoader, errorElement: <AppError /> },
  { path: "tiers/new", Component: NewTier, errorElement: <AppError /> },
  // T061 — tier settings, editable against `PUT /tiers/{id}`. Every record route below takes the
  // record's slug; a legacy GUID redirects to it (lib/services/catalog.ts's `byKey`).
  { path: "tiers/:slug", Component: TierDetail, loader: tierDetailLoader, errorElement: <AppError /> },
  // T062-T064 — the discount-rule builder + scope picker, composed.
  { path: "tiers/:slug/rules", Component: TierRules, loader: tierRulesLoader, errorElement: <AppError /> },
  // T065-T070 — the generated price list. There is no `.../:priceId/edit` route: no single-row GET
  // exists to hydrate one on a bookmarked/refreshed URL (see List.tsx's own header comment) — a row
  // is edited by expanding it in place on this same list.
  { path: "tiers/:slug/prices", Component: TierPrices, loader: tierPricesLoader, errorElement: <AppError /> },
];
